module.exports = __webpack_public_path__ + "assets/img/1009.b5234b05.svg";